import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "basic"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = { class: "width-wrap" }
const _hoisted_5 = { class: "page-content section" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "flashmessage flash-success"
}
const _hoisted_8 = {
  key: 1,
  class: "flashmessage flash-danger"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "flashmessage flash-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ng_container = _resolveComponent("ng-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('ConfirmEmail.title')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        (_ctx.showFormMessages)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.isSuccess)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('ConfirmEmail.success-message')) + " ", 1),
                    (!_ctx.isLoggedIn)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: { name: 'Login' }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('ConfirmEmail.success-link')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                : _createCommentVNode("", true),
              (_ctx.isInvalidToken)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_ctx.$t('ConfirmEmail.validation-link-error')) + " ", 1),
                      _createElementVNode("button", {
                        class: "button button--danger",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetConfirmEmail && _ctx.resetConfirmEmail(...args)))
                      }, _toDisplayString(_ctx.$t('ConfirmEmail.button-resend-validation-link')), 1)
                    ])
                  ]))
                : (_openBlock(), _createBlock(_component_ng_container, { key: 3 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "flashmessage flash-danger"
                        }, _toDisplayString(error), 1))
                      }), 128))
                    ]),
                    _: 1
                  }))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}